const EventEmitter = require('event-emitter-es6');

export default class Select extends EventEmitter {
    constructor(el) {
        super();
        this.handlers = {};
        this.el = el;
        this.id = this.el.dataset.id;
        this.activeEl = this.el.querySelector('.select__active');
        this.activeItem = {
            text: '',
            id: false
        };
        this.activeItemEl = false;
        this.isOpen = false;
        this.setInitialActiveItem();
        this.bindEvents();
    }

    setInitialActiveItem() {
        let item = this.el.querySelector('.select__item');
        this.setActiveItem(item);
    }

    bindEvents() {
        document.addEventListener('click', (event) => this.closeHandler(event));
        this.el.addEventListener('click', () => this.clickHandler());
        let items = this.el.querySelectorAll('.select__item');
        for (let i = 0; i < items.length; i++) {
            items[i].addEventListener('click', (event) => this.itemClickHandler(event));
        }
    }

    closeHandler(event) {
        if (!this.isOpen || event.target === this.activeEl) {
            return false;
        }

        this.close();
    }

    clickHandler() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.isOpen = true;
        this.el.classList.add('isOpen');
        this.emit('open');
    }

    close() {
        this.isOpen = false;
        this.el.classList.remove('isOpen');
        this.emit('close');
    }

    itemClickHandler(event) {
        let activeItem = event.target;
        if (activeItem !== this.activeItemEl) {
            this.setActiveItem(activeItem);
            this.emit('changed', this.activeItem.id, this.id);
        }
    }

    setActiveItemFromSlug(slug) {
        let item = this.el.querySelector(`.select__item[data-id="${slug}"]`);
        this.setActiveItem(item);
    }

    setActiveItem(el) {
        this.activeItemEl = el;
        this.activeItem.text = el.innerHTML;
        this.activeItem.id = el.dataset.id;
        this.activeEl.innerHTML = this.activeItem.text;
    }

    getActive() {
        return this.activeItem;
    }

    getActiveId() {
        return this.activeItem.id;
    }

    getId() {
        return this.id;
    }

    reset() {
        this.setInitialActiveItem();
    }
}



// WEBPACK FOOTER //
// ./src/components/select/select.js